import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { CSSProperties } from "react";
import { Icon } from "@mindlercare/ui-web";

type AlignSelf = CSSProperties["alignSelf"];

const TextCell = styled.div<{
  $alignSelf?: AlignSelf;
}>`
  align-self: ${(props) => props.$alignSelf ?? "center"};
  color: ${() => defaultTheme.COLORS.GRAY};
  fill: ${() => defaultTheme.COLORS.GRAY_DARK};
  font-weight: ${() => defaultTheme.FONT.WEIGHT.REGULAR};
  font-size: ${() => defaultTheme.FONT.SIZE.SMALL};
  display: flex;
  align-items: center;
`;

const StyledAccountIcon = styled(Icon.Account)`
  margin-right: 4px;
`;

export const Timestamp = ({
  children,
  alignSelf,
  status,
  showAccountSymbol = false,
  lowercased = false,
}: {
  children: Date | string;
  alignSelf?: AlignSelf;
  status: "sent" | "edited";
  showAccountSymbol?: boolean;
  lowercased?: boolean;
}) => {
  const { t } = useTranslation();
  const text = t(status === "edited" ? "LAST_EDITED" : "SENT_AT", {
    date: format(new Date(children), "MMMM d yyyy"),
  });
  return (
    <TextCell $alignSelf={alignSelf}>
      {showAccountSymbol && <StyledAccountIcon />}
      {lowercased ? text.toLowerCase() : text}
    </TextCell>
  );
};
